export const DATATYPE_INTEGER = 'Integer';
export const DATATYPE_DATE = 'Date';
export const DATATYPE_TIME = 'Time';
export const DATATYPE_DATETIME = 'DateTime';
// To show Yes or No for a boolean value
export const DATATYPE_BOOLEAN_YES_NO = 'BooleanYesNo';

export const SPECIAL_COLUMN_NOTIFICATION = 'spcol___notification';
export const SPECIAL_COLUMN_CHECKBOX = 'spcol___checkbox';
export const SPECIAL_COLUMN_ROWACTIONS = 'spcol___rowActions';

export const DEFAULT_PAGE_SIZE = 25

export const SORT_DIRECTION_ASCENDNG = 'asc'
export const SORT_DIRECTION_DESCENDING = 'desc'

